// extracted by mini-css-extract-plugin
module.exports = {"enemy":"Enemy_enemy__2eecE","header":"Enemy_header__1D_O7","opponent":"Enemy_opponent__P7QaJ","red":"Enemy_red__64tbQ","blue":"Enemy_blue__2bi3N"};